module.exports = require('./lib/SanityObservableMinimal')
